module.exports = __webpack_public_path__ + "img/slotxo.00c35db1.png";